import { jsx, jsxs } from 'react/jsx-runtime';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { deepmerge } from '@mui/utils';
import { createTheme } from '@mui/material';
import theme from '../../theme/theme.js';
import { HintProvider } from '../HintProvider/HintProvider.js';
import '../SpriteIcon/SpriteIcon.js';
import { ReactComponent as ForwardRef } from '../SpriteIcon/sprite.svg.js';
import DirectionCacheProvider from './DirectionCacheProvider.js';

const addDirectionToTheme = (theme, direction) => createTheme(deepmerge(theme, { direction: direction }));
const Provider = ({ children, theme: theme$1 = theme, defaultHintDuration, includeCssBaseline = true, direction = 'ltr', }) => {
    return (jsx(DndProvider, Object.assign({ backend: HTML5Backend }, { children: jsx(ThemeProvider, Object.assign({ theme: addDirectionToTheme(theme$1, direction) }, { children: jsx(DirectionCacheProvider, { children: jsxs(HintProvider, Object.assign({ defaultHintDuration: defaultHintDuration }, { children: [includeCssBaseline && jsx(CssBaseline, {}), jsx(ForwardRef, { id: "svg-sprite", style: { display: 'none' } }), children] })) }) })) })));
};

export { Provider as default };
//# sourceMappingURL=Provider.js.map
